package chand.wordvoyage.viewmodel

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import chand.wordvoyage.repository.FirestoreRepository
import chand.wordvoyage.repository.OpenAIRepository
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

sealed class WordGenerationState {
    object Idle : WordGenerationState()
    object Loading : WordGenerationState()
    data class Success(val word: String) : WordGenerationState()
    data class Error(val message: String) : WordGenerationState()
}

class WordViewModel(
    private val repository: OpenAIRepository,
    private val firestoreRepository: FirestoreRepository? = null,
    private val userId: String = ""
) : ViewModel() {

    private val _state = MutableStateFlow<WordGenerationState>(WordGenerationState.Idle)
    val state: StateFlow<WordGenerationState> = _state.asStateFlow()

    private val _isWordAvailable = MutableStateFlow<Boolean>(false)
    val isWordAvailable: StateFlow<Boolean> = _isWordAvailable.asStateFlow()

    fun generateWord() {
        viewModelScope.launch {
            _state.value = WordGenerationState.Loading
            _isWordAvailable.value = false

            // Fetch already seen words from history to avoid repetition
            val excludeWords = if (firestoreRepository != null && userId.isNotEmpty()) {
                firestoreRepository.getWordHistory(userId)
                    .getOrNull()
                    ?.map { it.word }
                    ?: emptyList()
            } else emptyList()

            repository.generateWord(excludeWords)
                .onSuccess { word ->
                    if (word.isNotEmpty()) {
                        _isWordAvailable.value = true
                        _state.value = WordGenerationState.Success(word)
                    } else {
                        _isWordAvailable.value = false
                        _state.value = WordGenerationState.Error("Received empty word")
                    }
                }
                .onFailure { exception ->
                    _isWordAvailable.value = false
                    _state.value = WordGenerationState.Error(
                        exception.message ?: "Failed to generate word"
                    )
                }
        }
    }


    override fun onCleared() {
        super.onCleared()
        repository.close()
    }
}

